import { getRequestData, searchRequestData } from '../../Utility/apiHelper';
import * as actionType from './type';



export const getAllproductType = (authToken) => async(dispatch) => {
    try {
        dispatch({
            type: actionType.REQUEST_PRODUCT_TYPE
        })

        const responseData = await getRequestData(`lookup/?type=product`);
        const sortedProduct = responseData?.data.sort((item, nextIntem) =>  item?.sequence - nextIntem?.sequence);
        
        dispatch({
            type: actionType.RECEIVE_PRODUCT_TYPE,
            payload: sortedProduct
        })

    } catch(error) {
    
    }
}

export const requestGetAllProducts = (queryparams) => async (dispatch)=>{
     try {
        dispatch({
            type: actionType.REQUEST_GET_ALL_PRODUCT
        })
        const productSearchUrl = `${process.env.REACT_APP_BASE_URL}products`;
        const responsedata = await searchRequestData(queryparams , productSearchUrl , false)
            dispatch({
                type: actionType.REQUEST_RECEIVED_ALL_PRODUCT,
                payload: responsedata?.data
            })
            
        } catch(error) {
        }
}

export const requestGetAllActiveProducts = (queryparams) => async (dispatch)=>{
     try {
        const productSearchUrl = `${process.env.REACT_APP_BASE_URL}products/search`;
        const responsedata = await searchRequestData(queryparams , productSearchUrl , false)
            dispatch({
                type: actionType.REQUEST_RECEIVED_ALL_ACTIVE_PRODUCT,
                payload: responsedata?.data
            })
            
        } catch(error) {
        }
}

export const emptyAllProducts = ()=>async (dispatch)=>{
            dispatch({
                type: actionType.REQUEST_EMPTY_ALL_PRODUCT,
                payload:    []
            })
}

export const requestGetProductById = (productId) => async (dispatch) => {
    try {
        dispatch({
            type: actionType.REQUEST_GET_PRODUCT_BY_ID
        });
        const responseData = await getRequestData(`products/${productId}`);
        dispatch({
            type: actionType.RECEIVE_GET_PRODUCT_BY_ID,
            payload: responseData?.data
        });
    } catch(error) {
    }
}